import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const PwdChangeAtKey = 'Pwd-Change-At-Key'
const UserKey = 'Admin-User'
const ClientRechargePhoneKey = 'Client-Recharge-Phone'
const AgentBalanceTransferKey = 'Agent-Balance-Transfer-Key'

export function getClientRechargePhone () {
  return Cookies.get(ClientRechargePhoneKey)
}

export function setClientRechargePhone (value) {
  return Cookies.set(ClientRechargePhoneKey, value)
}

export function getAgentBalanceTransferPhone () {
  return Cookies.get(AgentBalanceTransferKey)
}

export function setAgentBalanceTransferPhone (value) {
  return Cookies.set(AgentBalanceTransferKey, value)
}

export function getToken () {
  return Cookies.get(TokenKey)
}

export function getPwdChangeAt () {
  return Cookies.get(PwdChangeAtKey)
}

export function setToken (value) {
  return Cookies.set(TokenKey, value)
}

export function setPwdChangeAt (value) {
  return Cookies.set(PwdChangeAtKey, value)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function removePwdChangeAt () {
  return Cookies.remove(PwdChangeAtKey)
}

export function getUser () {
  return Cookies.get(UserKey)
}

export function setUser (user) {
  return Cookies.set(UserKey, user)
}

export function removeUser () {
  return Cookies.remove(UserKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js